<template>
    <div class="container remove-padding-margin">
        <div class="fixed-judul fixed-top">
            <div class="row justify-content-center align-items-center set-row">
                <div class="col-md-2 col-sm-2 col-2 remove-padding" @click="back">
                    <img src="../../assets/gambar/back-blue.svg" alt="">
                </div>
                <div class="col-md-8 col-sm-8 col-8 text-center remove-padding">
                    <h6 class="remove-margin font-16 font-colorcheck text-promo nomore">Pilih Jenis Komisi</h6>
                </div>
                <div class="col-md-2 col-sm-2 col-2">
                </div>
            </div>
        </div>
        <main class="add-padding-default">
            <div class="flex-100">
                <div class="flex-1 pad-top-66">
                    <div class="card-jenis-gaji  card-nonactive mar-bot-12 allblue" v-for="listkomisi in choice" :key="listkomisi.id" @click="selectRadio(listkomisi.id)">
                        <div class="custom-control custom-radio remove-padding-lr float-right">
                            <input type="radio"  name="customRadio" class="custom-control-input" v-bind:id="'list'+listkomisi.id" :value="listkomisi.id" v-model="idjeniskomisi">
                            <label class="custom-control-label" v-bind:for="'list'+listkomisi.id"></label>
                        </div>
                        <div class="letter-space-002 line-height-25 color-0000 remove-margin font-weight-600" v-bind:for="listkomisi.id" >{{listkomisi.nama}}</div>
                        <div class="font-14 line-height-20 letter-space-002 color-6f7 rupiah" v-for="divclone in listkomisi.detailKomisi" >Penjualan > {{divclone.total_omset | currency}} &#183 Komisi {{divclone.persentase_komisi.toFixed(2)}}%</div>
                    </div>
                    <div class="color-206CF p-t-12 p-d-20" @click="gocreate"><span><img src="../../assets/icons/plus_3.svg" alt=""></span> Buat baru...</div>
                </div>

                <div class="button-lanjut ">
                    <button class="btn btn-login btn-long remove-margin" @click="next" id="btnlist">
                        <span class="spinner-border spinner-border-sm" role="status"  aria-hidden="true"
                              v-if="isClicked === true"></span><span id="textbtnlist">Pilih</span>
                    </button>
                </div>

                <div class="modal fade" id="modalmaintance" role="dialog">
                    <div class="modal-dialog modal-lg  bani-modal">
                        <div class="modal-content">
                            <div class="modal-header">
                                <div class="nav-btn kiri"></div>
                                <h5 class="navbar-title text-center">Under Maintance</h5>
                                <div class="nav-btn kanan tutup">
                                    <img src="../../assets/img/x2.svg" data-dismiss="modal" alt="">
                                </div>
                            </div>
                            <div class="modal-body">
                                <div class="font-weight-bold color-206CF">Under Maintance</div>
                            </div>
                            <div class="modal-footer remove-mar-lr">
                                <div style="margin-right: 0px">
                                    <button type="button" class="btn btn-outline-primary btn-long" data-dismiss="modal" >UNDER MAINTANCE
                                    </button>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </main>
    </div>
</template>

<script>
    export default {
        name: "ListCommision",
        props:['setidkaryawankomisi'],
        data(){
            return{
                idkaryawan:this.setidkaryawankomisi,
                isClickedloader:false,
                isClicked:false,
                choice:[],
                aktiflist:{},
                namalist:'',
                detailjenisgaji:[],
                idjeniskomisi:'',
                requestHeaders: {
                    headers: {
                        'Authorization': 'Bearer ' + localStorage.getItem('token'),
                    }
                }
            }
        },
        mounted() {
            this.idkaryawan = this.$route.params.idkaryawan
            this.listkomisi()
        },
        methods:{
            back(){
                this.$emit("isaktif")
                this.$emit('getdetailkomisi')
            },

            gocreate(){
                this.$emit("gocreate")
            },

            async listkomisi(){
                $('#loadingPage').addClass('overlayLoading');
                $('#loadingPage').show()
              try {
                  const response = await this.$axios.get(this.$baseurl + '/masterData/meta/list_jenis_komisi_sales', this.requestHeaders)
                  if (response.data.status === true) {
                      $('#loadingPage').removeClass('overlayLoading');
                      $('#loadingPage').hide()
                      this.choice = [];
                      var data = response.data.data;
                      for (var i = 0; i < data.length; i++) {
                          this.choice.push({
                              nama:data[i].nama,
                              id:data[i].id,
                              detailKomisi:data[i].detail_jenisgaji_sales,
                          })
                      }
                      // this.toRp()
                  }
              }  catch (e) {
	              this.$catch_error_response(e)
	              $('#loadingPage').removeClass('overlayLoading');
	              $('#loadingPage').hide()
	              this.isClicked = false
	              $('#textBtn2').show()
	              $('#btnNext').prop('disabled', false);
              }
            },

            async next(){
                this.isClicked = true;
                $('#btnlist').prop('disabled', true);
                $('#textbtnlist').hide();
                try {
                    const post = new FormData
                    post.append('idkaryawan', this.setidkaryawankomisi);
                    post.append('idjeniskomisisales', this.idjeniskomisi)
                    const response = await this.$axios.post(this.$baseurl + '/masterData/karyawan/simpan_komisi_sales_karyawan', post, this.requestHeaders)
                    if(response.data.status===true){
                        this.isClicked = false;
                        $('#btnlist').prop('disabled', false);
                        $('#textbtnlist').show();
                        this.back()
                    }else{
                        this.isClicked = false;
                        $('#btnlist').prop('disabled', false);
                        $('#textbtnlist').show();
                    }

                }catch (e) {
                	this.$catch_error_response(e)
	                $('#loadingPage').removeClass('overlayLoading');
	                $('#loadingPage').hide()
	                this.isClicked = false;
	                $('#btnlist').prop('disabled', false);
	                $('#textbtnlist').show();
                }
            },
            selectRadio(id) {
                $("#list"+id).click();
            }

            // toRp(rupiah) {
            //     var bilangan = rupiah;
            //     var reverse = bilangan.toString().split('').reverse().join(''),
            //     ribuan = reverse.match(/\d{1,3}/g);
            //     ribuan = ribuan.join('.').split('').reverse().join('');
            //     return ribuan
            // }
        }
    }
</script>

<style scoped>
    .rupiah{

    }
</style>